import { LookupApi, SignupApi } from '@eventbrite/auth-lib';
import type { AsyncActionOptions, CreateAccountFormValues } from '../types';
import { createAccountPayload } from './adapters';

export const createAccount = async ({
    accountDetails,
    options,
}: {
    accountDetails: CreateAccountFormValues;
    options?: AsyncActionOptions;
}) => {
    if (options?.testingFlags.shouldError) {
        await new Promise((resolve) => setTimeout(resolve, 1700));
        throw new Error('Error creating account');
    }

    return await SignupApi.signupUser({
        data: createAccountPayload(accountDetails),
    });
};

export const lookupUserByEmail = async (
    email: string,
): Promise<LookupApi.ILookUpUserApiResponseProps> => {
    try {
        return await LookupApi.lookUpUser({ email });
    } catch (error) {
        // opting to silence the error returned if looking up the user fails.
        // if it's problematic, the call to create the account will fail and we will alert the creator.
        return {} as LookupApi.ILookUpUserApiResponseProps;
    }
};
